import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IonModal } from '@ionic/angular/standalone';

import { ActionSheetContentComponent } from './action-sheet-content/action-sheet-content.component';

@Component({
    selector: 'lib-action-sheet',
    imports: [CommonModule, ActionSheetContentComponent, IonModal],
    templateUrl: './action-sheet.component.html',
    styleUrl: './action-sheet.component.css'
})
export class ActionSheetComponent {
    /* eslint-disable */
    @Input() buttons:
        | Array<{
              text: string;
              role?: string;
              data?: {
                  action: string;
              };
          }>
        | null
        | undefined = undefined;
    @Input() showCancel: boolean = true;

    @Input() asModal: boolean = true;

    @Output() onActionClick = new EventEmitter();
    @Output() onDidDismiss = new EventEmitter();

    @ViewChild('actionSheet') actionSheet!: IonModal;

    constructor() {}

    async showActionSheet() {
        this.actionSheet.present();
    }

    dismissActionSheet() {
        this.actionSheet.dismiss();
    }

    didDismiss(event: CustomEvent) {
        this.onDidDismiss.emit(event);
    }

    onActionSheetButtonClick(value: any) {
        this.onActionClick.emit(value);
    }
}
